export default "__VITE_ASSET__CRl1khRB__"